/*
Maximum uploads allowed and 
allowed formats
*/
export const filesConfig = {
  maxAllowed: 4,
  allowed: ["doc", "docx", "pdf","jpeg","jpg"]
};